<template>
  <div class="task-schedule-main"> 
    <div class="gantt-container" :style="{ maxWidth: showHmsTrip ? 'calc(100% - 355px)' : 'calc(100%)' }">
    
      <div class="dropdown-list">
        <Dropdown :items="category" placeholder="List Category" itemKey="Description" :selectedObject.sync="selectedCategory"/>
        <Dropdown :items="viewOption" style="margin-left: 5px" placeholder="View Option" itemKey="Description" :selectedObject.sync="selectedViewOption"/>
      </div>

      <div class="date-container">
        
        <div class="date-title">Show timeline</div>
          <DateTimePicker placeholder="from" :value.sync="startDate" />
          <DateTimePicker placeholder="to" :value.sync="endDate" />
        <div class="refresh-container">

          
          <button @click="showRefreshDropdown = !showRefreshDropdown">{{ refreshText }}</button>
          <div v-if="showRefreshDropdown" class="refresh-dropdown">
            <div>Refresh Every:</div>
            <button @click="refreshIntervalClicked($event, 10)">10 seconds</button>
            <button @click="refreshIntervalClicked($event, 30)">30 seconds</button>
            <button @click="refreshIntervalClicked($event, 300)">5 minutes</button>
            <button @click="refreshIntervalClicked($event, 600)">10 minutes</button>
            <button @click="refreshIntervalClicked($event, 1800)">30 minutes</button>
            <button @click="refreshIntervalClicked($event, 3600)">1 hour</button>
            <button class="refresh-now" @click="refreshIntervalClicked($event, null)">Refresh Now</button>
            <button v-if="refreshInterval" class="cancel-refresh" @click="refreshIntervalClicked(null, null)">Cancel Refresh</button>
          </div>
        </div>
        <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
      </div>

      <div class="gantt-with-legends">

        <GanttChartV3 :items="ganttItems" @taskClicked="ganttTaskClicked" />
        
        <div class="gantt-legends">
          <div class="gantt-legends-items" v-for="(l, i) in legendsItems" :key="i">
            <div class="gantt-legends-color" :style="{ backgroundColor: l['ColorHexa'] }"></div>
            <div>{{ l['ColorDesc'] }}</div>
          </div>  
        </div>
      
      </div>
      <Loader class="gantt-loader" :loadingText="loadText" :isVisible.sync="loading"/>
    </div>
    



    <!-- <div class="hms-trip-container" :style="{ minWidth: showHmsTrip ? '350px' : '0', padding: showHmsTrip ? '5px' : '0' }">
      <div class="hms-title" :style="{ 'background-color': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? '#42a81d' : '#f24a01')}">
        <div class="header-back-button" v-if="consignmentDetails || (consignmentSelection['show'] || consignmentSelection['select'] != '')" @click="hideConsignmentDetails()">ᐊ</div>
        <div>{{ consignmentDetails ? (consignmentDetails['ConsignmentNo'] ? consignmentDetails['ConsignmentNo'].trim() : '') : (consignmentSelection['show'] || consignmentSelection['select'] != '') ? ((consignmentSelection['select'] != '') ? ('Select ' + consignmentSelection['select'] + ' job') : ('Port Booking - ' + hmsTitle)) : hmsTitle }}</div>
      </div>
      <div class="hms-body">
        <div v-if="hmsLoading" class="loading-hms-trips">Loading Trips . . .</div>
        <div v-if="hmsTrips.length > 0 && !consignmentDetails && !consignmentSelection['show']" class="hms-trips-container">
          <div v-for="(h, i) in hmsTrips" :key="i" class="hms-trips-content" @click="hmsBtn('portTripClick', h)" :style="{
            'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : ''),
            'display': hmsHideTrip(h) ? 'none' : ''}">
            <div class="trips-row">
              <div class="trips-left">{{ h['ContainerNo'] }}</div>
              <div class="trips-right">{{ h['ContSize'] }}{{ h['ContType'] ? h['ContType'].trim() : '' }}</div>
            </div>
            <div class="trips-row">
              <div class="trips-left">{{ h['ConsignmentNo'] ? h['ConsignmentNo'].trim() : '' }}</div>
              <div class="trips-right">{{ h['MovementType'] }}</div>
            </div>
            <div class="trips-row">
              <div class="trips-left">{{ h['BillToName'] ? h['BillToName'].trim() : '' }}</div>
              <div class="trips-right">[{{ h['FromArea'] ? h['FromArea'].trim() : '' }}-{{ h['ToArea'] ? h['ToArea'].trim() : '' }}]</div>
            </div>
            <Tooltip @click.native="showConsignmentDetails(h)" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
          </div>
        </div>
        <div v-if="consignmentDetails" class="consignment-details">
          <div class="consignment-row">
            <div class="consignment-left">Trip #</div>
            <div class="consignment-right">{{ consignmentDetails['Operator'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Cust</div>
            <div class="consignment-right">{{ consignmentDetails['BillToName'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Cont #</div>
            <div class="consignment-right">{{ consignmentDetails['ContainerNo'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">B2B</div>
            <div class="consignment-right">{{ consignmentDetails['B2BContainerNo'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">B2B CN</div>
            <div class="consignment-right">{{ consignmentDetails['B2BConsignmentNo'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Bkg Ref</div>
            <div class="consignment-right">{{ consignmentDetails['B2BBookingRefNo'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">From</div>
            <div class="consignment-right">{{ consignmentDetails['FromArea'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Tel No1</div>
            <div class="consignment-right">{{ consignmentDetails['ToTelNo1'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Tel No2</div>
            <div class="consignment-right">{{ consignmentDetails['ToTelNo2'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Address</div>
            <div class="consignment-right">{{ consignmentDetails['FromAddress'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">To</div>
            <div class="consignment-right">{{ consignmentDetails['ToArea'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Address</div>
            <div class="consignment-right">{{ consignmentDetails['ToAddress'] }}</div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">B2B To</div>
            <div class="consignment-right"></div>
          </div>
          <div class="consignment-row">
            <div class="consignment-left">Operator</div>
            <div class="consignment-right">{{ consignmentDetails['Operator'] }}</div>
          </div>
        </div>
        <div class="consignment-selection" v-if="consignmentSelection['show'] && !consignmentDetails">
          <div class="selection">
            <div class="title">
              <div class="text">Export</div>
              <div class="cancel" @click="hmsBtn('portreset', 'export')" :style="{ 'pointer-events': (consignmentSelection['export'] ? '' : 'none'), 'color': (consignmentSelection['export'] ? '' : '#fff3') }">&#9587;</div>
            </div>
            <div class="content">
              <div class="hms-trips-content" v-if="consignmentSelection['export']" :style="{
                'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}"
                 @click="hmsBtn('portselect', 'export')">
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['export'] ? (consignmentSelection['export']['ContainerNo'] ? consignmentSelection['export']['ContainerNo'].trim() : '') : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['export'] ? (consignmentSelection['export']['ContSize'] ? consignmentSelection['export']['ContSize'].trim() : '') : '' }}{{ consignmentSelection['export'] ? (consignmentSelection['export']['ContType'] ? consignmentSelection['export']['ContType'].trim() : '') : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['export'] ? (consignmentSelection['export']['ConsignmentNo'] ? consignmentSelection['export']['ConsignmentNo'].trim() : '') : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['export'] ? (consignmentSelection['export']['MovementType'] ? consignmentSelection['export']['MovementType'].trim() : '') : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['export'] ? (consignmentSelection['export']['BillToName'] ? consignmentSelection['export']['BillToName'].trim() : '') : '' }}</div>
                  <div class="trips-right">[{{ consignmentSelection['export'] ? (consignmentSelection['export']['FromArea'] ? consignmentSelection['export']['FromArea'].trim() : '') : '' }}-{{ consignmentSelection['export'] ? (consignmentSelection['export']['ToArea'] ? consignmentSelection['export']['ToArea'].trim() : '') : '' }}]</div>
                </div>
                <Tooltip @click.native="showConsignmentDetails(consignmentSelection['export'])" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
              </div>
              <div class="noselect" @click="hmsBtn('portselect', 'export')" v-else>Click to select</div>
              <div class="errMsg" v-if="consignmentSelection['exportMsg']['errMsg']" :style="{ 
                'background-color': (consignmentSelection['exportMsg']['status'] > 0 ? '' : '#b3ffc7'),
                'border': (consignmentSelection['exportMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                {{ consignmentSelection['exportMsg']['errMsg'] }}
              </div>
            </div>
          </div>
          <div class="selection">
            <div class="title">
              <div class="text">Import</div>
              <div class="cancel" @click="hmsBtn('portreset', 'import')" :style="{ 'pointer-events': (consignmentSelection['import'] ? '' : 'none'), 'color': (consignmentSelection['import'] ? '' : '#fff3') }">&#9587;</div>
            </div>
            <div class="content">
              <div class="hms-trips-content" v-if="consignmentSelection['import']" :style="{
                'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}"
                 @click="hmsBtn('portselect', 'import')">
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['import'] ? (consignmentSelection['import']['ContainerNo'] ? consignmentSelection['import']['ContainerNo'].trim() : '') : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['import'] ? (consignmentSelection['import']['ContSize'] ? consignmentSelection['import']['ContSize'].trim() : '') : '' }}{{ consignmentSelection['import'] ? (consignmentSelection['import']['ContType'] ? consignmentSelection['import']['ContType'].trim() : '') : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['import'] ? (consignmentSelection['import']['ConsignmentNo'] ? consignmentSelection['import']['ConsignmentNo'].trim() : '') : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['import'] ? (consignmentSelection['import']['MovementType'] ? consignmentSelection['import']['MovementType'].trim() : '') : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['import'] ? (consignmentSelection['import']['BillToName'] ? consignmentSelection['import']['BillToName'].trim() : '') : '' }}</div>
                  <div class="trips-right">[{{ consignmentSelection['import'] ? (consignmentSelection['import']['FromArea'] ? consignmentSelection['import']['FromArea'].trim() : '') : '' }}-{{ consignmentSelection['import'] ? (consignmentSelection['import']['ToArea'] ? consignmentSelection['import']['ToArea'].trim() : '') : '' }}]</div>
                </div>
                <Tooltip @click.native="showConsignmentDetails(consignmentSelection['import'])" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
              </div>
              <div class="noselect" @click="hmsBtn('portselect', 'import')" v-else>Click to select</div>
              <div class="errMsg" v-if="consignmentSelection['importMsg']['errMsg']" :style="{ 
                'background-color': (consignmentSelection['importMsg']['status'] > 0 ? '' : '#b3ffc7'),
                'border': (consignmentSelection['importMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                {{ consignmentSelection['importMsg']['errMsg'] }}
              </div>
            </div>
          </div>
          <div class="functions">
            <button @click="hmsBtn('portreset', '')" :disabled="consignmentSelection['loading'] || !(consignmentSelection['export'] || consignmentSelection['import'])">Reset</button>
            <button @click="hmsBtn('portbook', 'verify')" :disabled="consignmentSelection['loading'] || !(consignmentSelection['export'] || consignmentSelection['import'])">Confirm</button>
          </div>
          <div class="note">
            Select both for Export 	&amp; Import Job, else leave blank for single job. <br>
            e.g. Select ONLY Export for export job.
          </div>
          <div class="loader" v-if="consignmentSelection['loading']">
            <div class="load-text">{{ consignmentSelection['loadingMsg'] }}</div>
          </div>
        </div>
      </div>
      <div class="hms-footer">
        <button @click="hmsBtn('portselection', 'selection')" :disabled="hmsLoading || consignmentSelection['show'] || (consignmentSelection['select'] != '')">Port Booking</button>
        <button disabled>Dropoff In</button>
        <button disabled>...</button>
      </div>
    </div>
    <EntryPopup :show.sync="showBookingPopup" :title="consignmentBook['title']" :content.sync="consignmentBook['content']"
      :successMessages.sync="consignmentBook['successMessages']" :errorMessages.sync="consignmentBook['errorMessages']"
      :disabledSave="(this.consignmentBook['saved'] || this.consignmentBook['content']['popupData']['timeout'] <= 0)"
      :newStyle="true" :isComponent="true"
      @saved="hmsBtn('portbook', 'save')"/> -->
  </div>
</template>

<script>
/* eslint-disable */
import EntryPopup from '@/components/EntryPopup.vue';

import Gantt from '@/components/Gantt.vue';

export default {
  components: {
    EntryPopup,Gantt,
  },
  data: function() {
    return {
      loading: false,
      loadText: 'Loading',

      startDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00`),
      endDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:59`),

      ganttItems: [],
      legendsItems: [],

      showHmsTrip: false,
      hmsTitle: '',
      hmsLoading: false,
      hmsTrips: [],
      consignmentDetails: null,

      showRefreshDropdown: false,
      refreshTime: 0,
      refreshTimeStart: 0,
      refreshInterval: null,

      lastRefresh: '',

      consignmentSelection: {
        'show': false,
        'export': null,
        'import': null,
        'loading': false,
        'loadingMsg': 'Verifying',

        'select': '',
        'portbookType': '',

        'exportMsg': { 'status': 0, 'errMsg': '' },
        'importMsg': { 'status': 0, 'errMsg': '' },
      },
      consignmentBook: {
        'show': false,
        'title': '',
        'content': { type: 'PortBookingv2', popupData: { 'timeout': 300, 'loadText': '', 'jobs': [] }},
        'timeoutInterval': null,

        'saved': false,

        'successMessages': [],
        'errorMessages': [],
      },

      showBookingPopup: false,
    }
  },
  props: {
    selectedCategory: { type: Object, default: function() { return null } },
    selectedViewOption: { type: Object, default: function() { return null } },
  },
  computed: {
    refreshText: function() {
      if (!this.refreshInterval) { return 'Refresh' }
      else {
        let totalSeconds = this.refreshTime;
        let inMinute = Math.floor(totalSeconds / 60);

        if (totalSeconds >= 60) {
          return `Refresh in ${inMinute} minute${inMinute > 1 ? 's' : ''}`;
        } else {
          return `Refresh in ${this.refreshTime} seconds`;
        }
      }
    }
  },
  methods: {

      categorySelected: function(item) {
      var selectedCategory = this.statusCategories.filter((s) => {
        return s.Description == item;
      });

      console.log(selectedCategory[0].StatusListCategory);
    },



    getGanttDetails: async function() {
      this.loading = true;
      this.loadText = 'Getting Details';

      this.ganttItems = (await this.$apiCallV2(`/TaskSchedule/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.startDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.endDate, 'yyyy-MM-dd HH:mm')}&listCat=${this.selectedCategory['List Category'].trim()}&viewOpt=${this.selectedViewOption['View Option'].trim()}`));

      // this.ganttItems = [];
      // this.ganttItems = (await this.$apiCallV2(`/VehicleSchedule/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.startDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.endDate, 'yyyy-MM-dd HH:mm')}&viewType=TEAM_PM`, JSON.parse(localStorage.getItem('loginDetails')))).data;
      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss');

      this.loading = false;

      if (this.refreshTimeStart > 0) {
        this.refreshIntervalClicked(null, this.refreshTimeStart);
      }
    },
    ganttTaskClicked: function(e) {
      console.log('from vspage', e);
    },
    showConsignmentDetails: function(details) {
      // this.hmsTitle = details['ConsignmentNo'] ? details['ConsignmentNo'].trim() : '';
      this.consignmentDetails = details;
    },
    hideConsignmentDetails: function() {
      //-- Reset Port Booking (with conditions)
      // console.log(this.consignmentSelection['show']);
      // console.log(this.consignmentSelection['select']);
      if (!this.consignmentSelection['show'] && !this.consignmentDetails) {
        this.$set(this.consignmentSelection, 'show', true);
        this.$set(this.consignmentSelection, 'select', '');
      } else if ((this.consignmentSelection['select'] == '' && !this.consignmentDetails)) {
        this.$set(this.consignmentSelection, 'show', false);
        this.$set(this.consignmentSelection, 'export', null);
        this.$set(this.consignmentSelection, 'import', null);
        this.$set(this.consignmentSelection, 'select', '');
        this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': '' });
        this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': '' });
      }
      
      //-- Close details
      this.consignmentDetails = null;
    },

    refreshCountdown: function() {
      this.refreshTime--;
      if (this.refreshTime < 0) {
        this.refreshTime = this.refreshTimeStart;
      } else if (this.refreshTime == 0) {
        this.getGanttDetails();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    refreshIntervalClicked: function(e, seconds) {
      if (seconds) {
        this.refreshTime = seconds;
        if (e) { this.refreshTimeStart = seconds };
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(this.refreshCountdown, 1000);
      } else {
        if (e) {
          this.getGanttDetails();
        } else {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
          this.refreshTimeStart = 0;
        }
      }

      this.showRefreshDropdown = false;
    },

    //-- HMS view methods
    hmsHideTrip(trip) {
      console.log(trip);
      var trigger = false;

      if (this.consignmentSelection['export']) {
        if ((this.consignmentSelection['export']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['export']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }

      if (this.consignmentSelection['import']) {
        if ((this.consignmentSelection['import']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['import']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }


      return trigger;
    },

    //-- HMS Port Booking methods
    hmsBtn: async function(cmd, data) {
      switch(cmd) {
        case 'portselection':
          // console.log(data);
          this.$set(this.consignmentSelection, 'show', true);
          this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
          this.$set(this.consignmentBook, 'timeoutInterval', null);
          this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': '' });
          this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': '' });
          break;
        case 'portselect':
          // console.log(data);
          console.log(this.consignmentSelection);
          if (!this.consignmentDetails) {
            this.$set(this.consignmentSelection, 'select', data);
            this.$set(this.consignmentSelection, 'show', false);
            this.$set(this.consignmentSelection, data + 'Msg', { 'status': 0, 'errMsg': '' });
          }
          break;
        case 'portTripClick':
          if (this.consignmentSelection['select'] && !this.consignmentDetails) {
            this.$set(this.consignmentSelection, this.consignmentSelection['select'], data);
            // console.log(this.consignmentSelection);

            this.$nextTick(() => {
              this.$set(this.consignmentSelection, 'select', '');
              this.$set(this.consignmentSelection, 'show', true);
            });
          }
          break;
        case 'portreset':
          switch(data) {
            case 'export':
              this.$set(this.consignmentSelection, 'export', null);
              this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': '' });
              break;
            case 'import':
              this.$set(this.consignmentSelection, 'import', null);
              this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': '' });
              break;
            default:
              this.$set(this.consignmentSelection, 'export', null);
              this.$set(this.consignmentSelection, 'import', null);
              this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': '' });
              this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': '' });
              break;
          }
          break;
        case 'portbook':
          this.$set(this.consignmentSelection, 'portbookType', (this.consignmentSelection['export'] ? 'export' : '') + (this.consignmentSelection['import'] ? 'import' : ''));

          console.log(this.consignmentSelection['portbookType']);
          console.log(data);
          this.$nextTick(async () => {
            switch(data) {
              case 'verify':
                  this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': '' });
                  this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': '' });
                  this.$set(this.consignmentBook['content'], 'popupData', { 'timeout': 300, 'loadText': '', 'jobs': [] });

                  //-- Set Loading
                  this.$set(this.consignmentSelection, 'loading', true);

                  switch(this.consignmentSelection['portbookType']) {
                    case 'exportimport':
                      //-- Set variables
                      var reqCount = 0;

                      //-- Verify Data (export)
                      var dataToPostExport = {
                        'server': 'production',

                        'journeyguid': this.consignmentSelection['export']['JourneyGUID'] ? this.consignmentSelection['export']['JourneyGUID'].trim() : '',
                        'addjourneyguid': '',
                        'bookingtype': 'export',
                        'action': '',
                        'terminal': '',
                        'timeslot': '',
                        'notes': ''
                      }
                      
                      console.log('%cPost Data Export', 'color: hotpink', dataToPostExport);
                    
                      var requestExport = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPostExport);
                      console.log(requestExport);

                      //-- Verify Data (import)
                      var dataToPostImport = {
                        'server': 'production',

                        'journeyguid': this.consignmentSelection['import']['JourneyGUID'] ? this.consignmentSelection['import']['JourneyGUID'].trim() : '',
                        'addjourneyguid': '',
                        'bookingtype': 'import',
                        'action': '',
                        'terminal': '',
                        'timeslot': '',
                        'notes': ''
                      }
                      
                      console.log('%cPost Data Import', 'color: hotpink', dataToPostImport);
                    
                      var requestImport = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPostImport );
                      console.log(requestImport);

                      //-- Check incoming data
                      //-- EXPORT
                      if (!Array.isArray(requestExport) && (typeof requestExport == 'object')) {
                        this.$set(this.consignmentSelection, 'exportMsg', { 'status': 0, 'errMsg': 'Confirmed' });
                        reqCount += 1;
                      } else if (Array.isArray(requestExport)) {
                        if (requestExport[0]['Results'] > 0) {
                          console.log(requestExport[0]['ErrMsg']);
                          this.$set(this.consignmentSelection, 'exportMsg', { 'status': 1, 'errMsg': requestExport[0]['ErrMsg'] });
                        }
                      }

                      //-- IMPORT
                      if (!Array.isArray(requestImport) && (typeof requestImport == 'object')) {
                        this.$set(this.consignmentSelection, 'importMsg', { 'status': 0, 'errMsg': 'Confirmed' });
                        reqCount += 1;
                      } else if (Array.isArray(requestImport)) {
                        if (requestImport[0]['Results'] > 0) {
                          console.log(requestImport[0]['ErrMsg']);
                          this.$set(this.consignmentSelection, 'importMsg', { 'status': 1, 'errMsg': requestImport[0]['ErrMsg'] });
                        }
                      }
    
                      if (reqCount >= 2) {
                        //-- Set Popup title
                        var impExp = 'EXP';
                        var consignmentNo = this.consignmentSelection['export']['ConsignmentNo'] ? this.consignmentSelection['export']['ConsignmentNo'].trim() : 'Consignment #';
                        var containerNo = this.consignmentSelection['export']['ContainerNo'] ? this.consignmentSelection['export']['ContainerNo'].trim() : 'Container #';

                        var title = 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                        impExp = 'IMP';
                        consignmentNo = this.consignmentSelection['import']['ConsignmentNo'] ? this.consignmentSelection['import']['ConsignmentNo'].trim() : 'Consignment #';
                        containerNo = this.consignmentSelection['import']['ContainerNo'] ? this.consignmentSelection['import']['ContainerNo'].trim() : 'Container #';

                        title += '[' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                        this.$set(this.consignmentBook, 'title', title);
                        
                        //-- Set Popup data
                        this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection['export'], requestExport), Object.assign({}, this.consignmentSelection['import'], requestImport)]);

                        //-- Set Popup show
                        this.showBookingPopup = true;
                        // this.$set(this.consignmentBook, 'show', true);
                        this.$set(this.consignmentBook, 'saved', false);
                        this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                        
                        //-- Clear Interval or Reset
                        clearInterval(this.consignmentBook['timeoutInterval']);
                        this.$set(this.consignmentBook, 'timeoutInterval', null);
                        this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                          if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                            this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                          } else {
                            clearInterval(this.consignmentBook['timeoutInterval']);
                            this.$set(this.consignmentBook, 'timeoutInterval', null);
                          }
                        }, 1000));
                      }

                      break;
                    case 'export':
                    case 'import':  
                      //-- Verify Data (export OR import)
                      var dataToPost = {
                        'server': 'production',

                        'journeyguid': this.consignmentSelection[this.consignmentSelection['portbookType']]['JourneyGUID'] ? this.consignmentSelection[this.consignmentSelection['portbookType']]['JourneyGUID'].trim() : '',
                        'addjourneyguid': '',
                        'bookingtype': this.consignmentSelection['portbookType'],
                        'action': '',
                        'terminal': '',
                        'timeslot': '',
                        'notes': ''
                      }
                      
                      console.log('%cPost Data', 'color: hotpink', dataToPost);
                    
                      var request = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPost );
                      console.log(request);

                      //-- Check incoming data
                      if (!Array.isArray(request) && (typeof request == 'object')) {
                        this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 0, 'errMsg': 'Confirmed' });

                        //-- Set Popup title
                        var impExp = ((this.consignmentSelection['portbookType'] == 'export') ? 'EXP' : 'IMP');
                        var consignmentNo = this.consignmentSelection[this.consignmentSelection['portbookType']]['ConsignmentNo'] ? this.consignmentSelection[this.consignmentSelection['portbookType']]['ConsignmentNo'].trim() : 'Consignment #';
                        var containerNo = this.consignmentSelection[this.consignmentSelection['portbookType']]['ContainerNo'] ? this.consignmentSelection[this.consignmentSelection['portbookType']]['ContainerNo'].trim() : 'Container #';

                        this.$set(this.consignmentBook, 'title', 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ');
                        
                        //-- Set Popup data
                        this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection[this.consignmentSelection['portbookType']], request)]);

                        //-- Set Popup show
                        this.$set(this.consignmentBook, 'show', true);
                        this.$set(this.consignmentBook, 'saved', false);  
                        this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                        
                        //-- Clear Interval or Reset
                        clearInterval(this.consignmentBook['timeoutInterval']);
                        this.$set(this.consignmentBook, 'timeoutInterval', null);
                        this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                          if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                            this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                          } else {
                            clearInterval(this.consignmentBook['timeoutInterval']);
                            this.$set(this.consignmentBook, 'timeoutInterval', null);
                          }
                        }, 1000));

                      } else if (Array.isArray(request)) {
                        if (request[0]['Results'] > 0) {
                          console.log(request[0]['ErrMsg']);
                          this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 1, 'errMsg': request[0]['ErrMsg'] });
                        }
                      }
                      break;
                  }

                  //-- Set Loading
                  this.$set(this.consignmentSelection, 'loading', false);
                break;
              case 'save':
                this.$set(this.consignmentBook, 'successMessages', []);
                this.$set(this.consignmentBook, 'errorMessages', []);

                console.log(this.consignmentBook['content']['popupData']['jobs']);
                
                if (this.consignmentBook['content']['popupData']['jobs'].filter((d, i) => { return d['timeslotsSel']; })['length'] > 0) {
                  //-- Get data of 1st item
                  var jobData = this.consignmentBook['content']['popupData']['jobs'][0];

                  //-- Save Data (Final, or known as 2nd API call)
                  var dataToPost = {
                    'server': 'production',

                    'journeyguid': (this.consignmentSelection['portbookType'] == 'exportimport') ? (this.consignmentSelection['export']['JourneyGUID'] ? this.consignmentSelection['export']['JourneyGUID'].trim() : '') : (this.consignmentSelection[this.consignmentSelection['portbookType']]['JourneyGUID'] ? this.consignmentSelection[this.consignmentSelection['portbookType']]['JourneyGUID'].trim() : ''),
                    'addjourneyguid': (this.consignmentSelection['portbookType'] == 'exportimport') ? (this.consignmentSelection['import']['JourneyGUID'] ? this.consignmentSelection['import']['JourneyGUID'].trim() : '') : '',
                    'bookingtype': this.consignmentSelection['portbookType'],
                    'action': 'N',
                    'terminal': (jobData ? (jobData['usecontterminal'] ? jobData['usecontterminal'].trim() : '') : ''),
                    'timeslot': (jobData ? (jobData['timeslotsSel'] ? jobData['timeslotsSel']['start'].trim() : '') : ''),
                    'notes': (jobData ? (jobData['remarks'] ? jobData['remarks'].trim() : '') : ''),
                  }
                  
                  console.log('%cPost Data', 'color: hotpink', dataToPost);
                  this.$set(this.consignmentBook['content']['popupData'], 'loadText', 'Saving');

                  var request = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPost );
                  console.log(request);
                  
                  if (Array.isArray(request)) {
                    if (request[0]['Results'] <= 0) {
                      console.log('%cPortB Success', 'color: green;', request);
                      
                      this.$set(this.consignmentBook, 'successMessages', ['Booking successful.']);
                      this.$set(this.consignmentBook, 'saved', true);
                    } else { 
                      console.log('%cPortB Error', 'color: red;', request[0]['ErrMsg']);

                      this.$set(this.consignmentBook, 'errorMessages', [request[0]['ErrMsg']]);
                    }

                  } else if (typeof request == 'object') {
                    console.log('%cPortB Success', 'color: green;', request);
                  } else {
                    console.log('%cPortB Error', 'color: red;', request);

                    this.$set(this.consignmentBook, 'errorMessages', [request]);
                  }

                  this.$set(this.consignmentBook['content']['popupData'], 'loadText', '');
                } else {
                  this.$set(this.consignmentBook, 'errorMessages', ['No timeslot was selected, please select a timeslot.']);
                }
                break;
            }
          });
          break;
      }
    },
  },
  async mounted() {
    this.loading = true;

    this.loadText = 'Getting Status List';
    var getCategory = await this.$apiCallV2('/TaskSchedule/GetListMaster?masterFile=statuslistcategory');
    this.category = getCategory;
    this.selectedCategory = this.category[0];

    this.loadText = 'Getting View Option';
    var getViewOption = await this.$apiCallV2('/TaskSchedule/GetListMaster?masterFile=statusviewoption');
    this.viewOption = getViewOption;
    this.selectedViewOption = this.viewOption[0];
    
    await this.getGanttDetails();

    this.loadText = 'Getting Legends';
    this.legendsItems = (await this.$apiCallV2('/TaskSchedule/GetLegends?viewType=VESSEL_JOB'));

    this.loading = false;
  },
  watch: {
    showBookingPopup: function(val) {
      if (this.refreshInterval) {
        if (val) {
          clearInterval(this.refreshInterval);
        } else {
          this.refreshIntervalClicked(null, this.refreshTime);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.task-schedule-main {
  width: 100%;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;


.dropdown-list {
  margin-top: 9px;
  top: 1px;
  position: absolute;
  display: flex;
  
}

  > .gantt-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    position: relative;

    > .date-container {
      display: flex;
      align-items: center;
      justify-content: flex-end; //zx
      padding: 5px 0;

      > * {
        margin-left: 5px;
      }

      > .date-title {
        height: 100%;
        position: relative;
        top: 3px;
      }

      > .refresh-container {
        position: relative;
        min-width: 200px;

        > button {
          width: 100%;
        }

        > .refresh-dropdown {
          position: absolute;
          top: 100%;
          background-color: white;
          width: 100%;
          z-index: 10;
          padding: 5px;
          border-width: 1px;
          border-style: solid;
          border-color: transparent black black black;

          > button {
            width: 100%;
            border-radius: 0;
            padding: 3px;
          }

          > .refresh-now {
            margin: 5px 0;
          }

          > .cancel-refresh {
            background-color: red;
            color: white;
          }
        }
      }

      > .last-refresh {
        margin: 0 5px;
      }
    }

    > .gantt-with-legends {
      height: calc(100% - 40px);
      display: flex;

      > .gantt-legends {
        min-width: 100px;
        max-width: 100px;
        height: fit-content;
        font-size: 10px;
        margin-left: 5px;

        > .gantt-legends-items {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          > .gantt-legends-color {
            max-width: 20px;
            min-width: 20px;
            max-height: 20px;
            min-height: 20px;
            margin-right: 3px;
          }
        }
      }
    }

    > .gantt-loader {
      position: absolute;
      left: 0;
      top: 0 !important;
      height: 100% !important;
      width: 100%;
    }
  }

  > .vehicle-schedule-body {
    width: auto;
    height: 100%;
    padding: 5px;
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    overflow-x: scroll;

    > .portBPopup {
      width: auto;
      height: auto;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
  }

  > .hms-trip-container {
    background-color: white;
    padding: 0;
    border-radius: 5px;
    margin-left: 5px;
    width: 0;
    transition: 0.3s;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > * {
      width: 100%;
      padding: 5px;
      display: flex;
    }

    > .hms-title {
      min-height: 30px;
      max-height: 30px;
      // background-color: #f24a01;
      align-items: center;
      color: white;
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      border-radius: 5px 5px 0 0;

      > .header-back-button {
        padding-left: 5px;
        padding-right: 10px;
        cursor: pointer;
      }
    }

    > .hms-body {
      height: 100%;
      background-color: #eaeaea;
      overflow: auto;

      > .loading-hms-trips {
        width: 100%;
        text-align: center;
      }

      > .hms-trips-container {
        width: 100%;
        
        > .hms-trips-content {
          background-color: white;
          border: 1px solid black;
          width: 100%;
          padding: 5px;
          margin-bottom: 5px;
          position: relative;
          padding-right: 25px;
          user-select: none;

          > .trips-row {
            display: flex;
            align-items: flex-start;

            > .trips-left {
              width: fit-content;
              flex-grow: 1;
              font-weight: bold;
              padding-right: 5px;
            }

            > .trips-right {
              max-width: 100px;
              width: fit-content;
              text-align: right;
              white-space: nowrap;
            }
          }

          > .trips-tooltip {
            position: absolute;
            right: 3px;
            bottom: 3px;
          }
        }
      }

      > .consignment-details {
        width: 100%;

        > .consignment-row {
          display: flex;

          > .consignment-left {
            min-width: 70px;
            font-weight: bold;
          }

          > .consignment-right {
            flex-grow: 1;
          }
        }
      }

      
      > .consignment-selection {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        > .selection {
          width: 100%;
          display: flex;
          margin: 0 0 10px 0;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          border: solid 1px #42a81d;
          border-radius: 5px;
          
          > .title {
            width: 100%;
            height: 24px;
            padding: 0 5px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #42a81d;
            color: #ffffff;
            border-radius: 3px 3px 0 0;

            > .text {
              width: auto;
              height: 100%;
              padding: 0 5px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }

            > .cancel {
              width: 16px;
              height: 16px;
              padding: 0 0 2px 0;
              font-size: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #dddddd;
              user-select: none;
              cursor: pointer;
            }

            > .cancel:hover {
              color: #ffffff;
            }
          }

          > .content {
            width: 100%;
            padding: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            > .hms-trips-content {
              background-color: white;
              border: 1px solid black;
              width: 100%;
              padding: 5px;
              position: relative;
              padding-right: 25px;
              user-select: none;

              > .trips-row {
                display: flex;
                align-items: flex-start;

                > .trips-left {
                  width: fit-content;
                  flex-grow: 1;
                  font-weight: bold;
                  padding-right: 5px;
                }

                > .trips-right {
                  max-width: 100px;
                  width: fit-content;
                  text-align: right;
                  white-space: nowrap;
                }
              }

              > .trips-tooltip {
                position: absolute;
                right: 3px;
                bottom: 3px;
              }
            }

            > .noselect {
              width: 100%;
              height: 65px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: solid 1px #0001;
              color: gray;
              user-select: none;
              cursor: pointer;
            }

            > .noselect:hover {
              border: solid 1px #0004;
            }

            > .errMsg { 
              width: 100%;
              height: auto;
              padding: 5px;
              margin: 5px 0 0 0;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              background-color: #ffd9d9;
              border: solid 1px red;
            }
          }
        }

        > .functions {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          
          > button {
            margin: 0 0 0 5px;
          }
        }

        > .note {
          width: 100%;
          height: auto;
          padding: 20px 0 0 0;
          font-size: 12px;
          color: gray;
          user-select: none;
        }

        > .loader {
          width: auto;
          height: auto;
          position: absolute;
          top: -5px;
          bottom: -5px;
          left: -5px;
          right: -5px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #0004;
          z-index: 10;

          > .load-text {
            width: auto;
            height: auto;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ffffff;
            border-radius: 5px;
            box-shadow: 0 0 8px #0004;
            user-select: none;
          }
        }
      }
    }
    

    > .hms-footer {
      min-height: 40px;
      max-height: 40px;
      background-color: #eaeaea;
      align-items: center;
      border-top: 1px solid rgba(64,64,64,0.5);

      > button {
        margin: 0 5px 0 0;
      }
    }
  }
}
</style>